import React, { useEffect } from "react";
import { Point } from "yfiles";
import { useRemoteCursors } from "./RemoteCursorsProvider";
import { RemoteCursorOverlay } from "./RemoteCursorOverlay";
function RemoteCursorsGraph({ graph }) {
    const { setLocalCursorPosition, cursors } = useRemoteCursors();
    useEffect(() => {
        if (!graph || !graph.div)
            return;
        const container = graph.div;
        const handleMouseMove = (e) => {
            if (!graph || !container)
                return;
            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const worldPoint = graph.toWorldCoordinates(new Point(x, y));
            setLocalCursorPosition(worldPoint);
        };
        const handleMouseLeave = () => {
            setLocalCursorPosition(null);
        };
        container.addEventListener("mousemove", handleMouseMove);
        container.addEventListener("mouseleave", handleMouseLeave);
        return () => {
            container.removeEventListener("mousemove", handleMouseMove);
            container.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, [graph, setLocalCursorPosition]);
    if (!graph || !graph.div)
        return null;
    return (React.createElement(React.Fragment, null,
        cursors.map(cursor => {
            const viewPoint = graph.toViewCoordinates(cursor.position);
            const isVisible = viewPoint.x >= 0 &&
                viewPoint.y >= 0 &&
                viewPoint.x <= graph.div.clientWidth &&
                viewPoint.y <= graph.div.clientHeight;
            if (!isVisible)
                return null;
            return (React.createElement(RemoteCursorOverlay, { key: cursor.id, cursor: {
                    ...cursor,
                    position: {
                        x: viewPoint.x,
                        y: viewPoint.y
                    }
                } }));
        }),
        ";"));
}
export default RemoteCursorsGraph;
